import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import PaymentRadio from '../../../../payment/PaymentRadio';
import OnEnterTrigger from '../../../../general/OnEnterTrigger';
import { translate as t } from '../../../../../lib/I18n';
import { Col } from 'react-bootstrap';
import { PaymentForms } from './components/PaymentForms';
import ADRPaymentMethodsForm from '../../../../../records/customer/ADRPaymentMethodsForm';
import { oneClickDelayRepayReimbursementMethods } from '../../../../../constants/AppConstants';
import FeatureFlagStore from '../../../../../stores/FeatureFlagStore';


const paymentMethodsList = [
    { label: 'Electronic Bank Transfer', key: oneClickDelayRepayReimbursementMethods.BACS },
    { label: 'eVoucher', key: oneClickDelayRepayReimbursementMethods.EVOUCHERS },
    { label: 'PayPal', key: oneClickDelayRepayReimbursementMethods.PAYPAL },
    { label: 'Charity', key: oneClickDelayRepayReimbursementMethods.CHARITY },
];

const SelectPaymentMethod = ({ form, handleFormChange, showPaymentForm, isValidBACS }) => {

    const { method } = form;

    const updateFormField = (field, value) => {
        handleFormChange((prevForm) => prevForm.set(field, value));
    };

    return (
        <Col xs={12}>
            <h2 className="auto-dr__header">{t('auto-dr.subscribe.modal-payment')}</h2>
            <p>{t('auto-dr.subscribe.compliance')}.</p>
            {showPaymentForm && (
                <React.Fragment>
                <div className="auto-delay-repay-notification-preferences auto-dr__payment-wrapper">
                        {paymentMethodsList.map(({ key, label }) => {
                            if (key === oneClickDelayRepayReimbursementMethods.CHARITY
                                    && !FeatureFlagStore.get('enableOcdrCharityReimbursementMethod')) {
                                return null;
                            }

                            return (
                                <div
                                    className="auto-dr__payment-item auto-dr__payment-item--notification-preference"
                                >
                                    <OnEnterTrigger
                                        className={classnames('payment__selector', {
                                            'payment__selector--selected': method === key
                                        })}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            updateFormField('method', key);
                                        }}
                                        srOnly={label}
                                        disabled={ false }
                                    >
                                        <PaymentRadio
                                            className="payment__selector__radio-icon small"
                                            isSelected={method === key}
                                        />
                                        <div className="auto-dr__payment-item__label">{label}</div>
                                    </OnEnterTrigger>
                                </div>
                            );
                        })}
                </div>
                <div className="auto-delay-repay-notification-preferences margin-left--sm margin-right--sm">
                    <PaymentForms form={form} updateFormField={updateFormField} isValidBACS={isValidBACS} />
                    <p className="margin-top--sm">{t('auto-dr.subscribe.change')}.</p>
                </div>
                </React.Fragment>
            )}
        </Col>
    );
};

SelectPaymentMethod.propTypes = {
    handleFormChange: PropTypes.func.isRequired,
    form: PropTypes.instanceOf(ADRPaymentMethodsForm).isRequired,
    isValidBACS: PropTypes.func,
    showPaymentForm: PropTypes.bool,
    setShowPaymentForm: PropTypes.func,
};

export default SelectPaymentMethod;



// WEBPACK FOOTER //
// ./src/components/account/subscribeDelayRepay/components/SelectPaymentMethod/index.js